"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isDecimal = _interopRequireDefault(require("./isDecimal"));
var _isSexagesimal = _interopRequireDefault(require("./isSexagesimal"));
var _sexagesimalToDecimal = _interopRequireDefault(require("./sexagesimalToDecimal"));
var _constants = require("./constants");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var isValidLatitude = function isValidLatitude(value) {
  if ((0, _isDecimal.default)(value)) {
    if (parseFloat(value) > _constants.MAXLAT || value < _constants.MINLAT) {
      return false;
    }
    return true;
  }
  if ((0, _isSexagesimal.default)(value)) {
    return isValidLatitude((0, _sexagesimalToDecimal.default)(value));
  }
  return false;
};
var _default = isValidLatitude;
exports.default = _default;